<div class="PGImportedWidget">
    @if(importedJob; as job) {
        @if(importedProgress; as progress) {
            @if(importedItem; as item) {
                <div ngbDropdown>
                    <div ngbDropdownToggle class="btn btn-link p-0">
                        <b>{{ 'pg-imported-widget.imported' | locTranslate }} </b>
                        <span>{{ progress.time_end | locFormat:'datetime' }}</span>
                    </div>
                    <div ngbDropdownMenu>
                        <div class="dropdown-item-text">
                            <i class="{{ getImportTypeIcon(job.type) }} me-2"></i>
                            <span>{{ 'pg-import.from-' + job.type | locTranslate }}</span>
                        </div>
            
                        @if(job.type == 'entourance') {
                            <div class="dropdown-item-text">
                                <b>{{ 'pg-import.installation' | locTranslate }}:&nbsp;</b>
                                <span>{{ getImportInstallationName(job.APIUrl) }}</span>
                            </div>

                            @if (importedRealm) {
                                <div class="dropdown-item-text">
                                    <b>{{ 'pg-import.realm' | locTranslate }}:&nbsp;</b>
                                    <span>{{ importedRealm.name }}</span>
                                </div>
                            }
                        }
                            
                        @if(job.type == 'entourance' || job.type == 'wordpress' || job.type == 'dhm' || job.type == 'eppoi') {
                            <div class="dropdown-item-text">
                                <b>{{ 'pg-import.source' | locTranslate }}:&nbsp;</b>
                                <span>{{ getImportedItemDisplay(item) }}</span>
                            </div>
                        }
                    </div>
                </div>
    
            }
        }
    }
</div>
